import { BaseIcon, BaseIconProps } from "./baseIcon";

export const SelectedChoicesFillIcon = (props: BaseIconProps) => {
  return (
    <BaseIcon {...props} viewBox="0 0 14 14">
      <path
        d="M7.0083 1.16602C10.2299 1.16604 12.8411 3.7775 12.8413 6.99902C12.8413 10.2208 10.23 12.833 7.0083 12.833C3.78667 12.833 1.17529 10.2208 1.17529 6.99902C1.17554 3.77748 3.78682 1.16602 7.0083 1.16602ZM10.396 4.08301C10.222 4.08303 10.0402 4.13922 9.90771 4.26562L5.64111 8.33105L4.09229 6.85449C3.82733 6.6018 3.38148 6.60197 3.11572 6.85449C2.85068 7.10722 2.85068 7.53236 3.11572 7.78516L5.15381 9.72754C5.41881 9.97998 5.86442 9.98002 6.12939 9.72754L10.8843 5.19629C11.1499 4.94355 11.1498 4.51844 10.8843 4.26562C10.7518 4.1392 10.57 4.08301 10.396 4.08301Z"
        className="oui-fill-base-contrast-80"
      />
    </BaseIcon>
  );
};
